"use client";

import { SkeletonLine, SkeletonStack } from "@health/ui";

/**
 * Loading skeleton mirroring the open PatientProfile bottom-sheet — header
 * row, a couple of section blocks of label/value rows, and a footer CTA.
 *
 * Lives in its own file so {@link WidgetLoadingRegistry} can import it
 * without pulling in the lazy-loaded {@link PatientProfile} chunk.
 */
const PROFILE_SKELETON_SECTIONS: Array<Array<{ label: "sm" | "md"; value: "sm" | "md" }>> = [
  [
    { label: "sm", value: "md" },
    { label: "md", value: "sm" },
  ],
  [
    { label: "sm", value: "md" },
    { label: "md", value: "md" },
    { label: "sm", value: "sm" },
  ],
];

export function PatientProfileSkeleton() {
  return (
    <div className="w-full">
      <div className="rounded-2xl bg-widget-bg border border-secondary/60 shadow-sm overflow-hidden">
        <div className="flex items-center justify-between px-4 py-3 border-b border-secondary/40">
          <SkeletonLine $size="text" $width="sm" />
          <SkeletonLine $size="caption" $width="xs" className="size-4" />
        </div>
        <div className="px-4 py-3 space-y-4">
          {PROFILE_SKELETON_SECTIONS.map((rows, i) => (
            <SkeletonStack key={i}>
              <SkeletonLine $size="caption" $width="sm" />
              {rows.map((r, j) => (
                <div key={j} className="flex justify-between gap-2">
                  <SkeletonLine $size="text" $width={r.label} />
                  <SkeletonLine $size="text" $width={r.value} />
                </div>
              ))}
            </SkeletonStack>
          ))}
        </div>
        <div className="px-4 py-3 border-t border-secondary/40">
          <SkeletonLine $size="text" $width="md" className="mx-auto" />
        </div>
      </div>
    </div>
  );
}
